<template lang="pug">
  div
    filter-table(
      layout="text"
      @inputSearchFilter="inputSearchFilter")
    .credits-table.ods-mt-6
      ods-table(
        v-loading="loadingTable"
        style='width: 100%'
        :data='tableDataRendered'
        :default-sort = "{prop: 'code', order: 'descending'}"
        )
        ods-table-column(prop='fecemimov.valueDate' label='Fecha del recibo' sortable)
          template(slot-scope="scope")
            div {{ scope.row.fecemimov | formatDateLocale }}
        ods-table-column(prop='cuenta' label='Cuenta asociada' sortable)
          template(slot-scope="scope")
            span {{ scope.row.iban | formatAccount(scope.row.ctacargo) }}
        ods-table-column(prop='imprec' label='Importe recibo' sortable)
          template(slot-scope="scope")
            div {{ scope.row.imprec | toCurrencyCode(scope.row.clamon) }}
        ods-table-column(prop='descodproced' label='Tipo' sortable)
        ods-table-column(prop='dessituarec' label='SITUACIÓN' sortable class-name="cell-tag")
          template(slot-scope="scope")
            ods-tag(:type="getType(scope.row.situarec)") {{ scope.row.dessituarec }}

      div.footer
        paginator(
          :isNextPage="indMasDatos"
          :currentPage="currentPage"
          @buttonPrevAction="getPrevPage"
          @buttonNextAction="getNextPage")
        //- ods-pagination.footer__page(
        //- :page-sizes='[5, 10, 50, 100]',
        //- :page-size="itemsPerPage",
        //- layout='prev, pager, next',
        //- :total='totalData'
        //- @size-change='handleSizeChange',
        //- @current-change='handleCurrentChange'
        //- style="text-align: right; margin-top: 20px")

</template>

<script>
import { mapGetters } from 'vuex'
import FilterTable from '@/components/shared/FilterTable'
import Paginator from '@/components/shared/Paginator'

export default {
  name: 'ReceiptsTable',

  components: {
    FilterTable,
    Paginator
  },

  props: {
    comercio: {
      required: true
    }
  },

  data () {
    return {
      defaultParams: {
        codproceso: 3,
        codcom: this.comercio.codcom
      },
      paginationParams: null,
      tableData: null,
      tableDataRendered: null,
      currentPage: null,
      indMasDatos: null,
      loadingTable: false
      // tableData: this.data,
      // currentPageData: 1,
      // totalData: 0
    }
  },

  // watch: {
  //   data (newData, oldData) {
  //     this.tableData = newData
  //     this.totalData = newData.length
  //     this.handlePagination()
  //   }
  // },

  computed: {
    ...mapGetters([
      // 'itemsPerPage'
    ])
  },

  methods: {
    async getData (params) {
      this.loadingTable = true
      // Listado de Recibos
      await this.$store.dispatch('listReceipts', params)
        .then((res) => {
          this.loadingTable = false
          if (res.registros) {
            this.tableData = Array.isArray(res.registros) ? res.registros : [res.registros]
            this.tableDataRendered = this.tableData
          } else {
            this.tableData = null
            this.tableDataRendered = this.tableData
          }
          this.currentPage = res.pantPagina
          this.indMasDatos = res.indMasDatos
          this.paginationParams = {
            claveInicio: res.claveInicio,
            claveFin: res.claveFin
          }
        })
    },

    getInitialData () {
      const params = {
        ...this.defaultParams
      }
      this.getData(params)
    },

    getPrevPage () {
      const params = {
        ...this.defaultParams,
        ...this.paginationParams,
        retroceder: true
      }
      this.getData(params)
    },

    getNextPage () {
      const params = {
        ...this.defaultParams,
        ...this.paginationParams,
        avanzar: true
      }
      this.getData(params)
    },

    inputSearchFilter (text) {
      this.tableDataRendered = this.tableData.filter((res) => {
        return res.fecemimov.valueDate.toLowerCase().includes(text.toLowerCase()) ||
          this.$options.filters.formatAccount(res.iban, res.ctacargo).replace(/\s/g, '').toLowerCase().includes(text.replace(/\s/g, '').toLowerCase()) ||
          res.imprec.toString().replace('.', ',').toLowerCase().includes(text.toLowerCase()) ||
          res.descodproced.toLowerCase().includes(text.toLowerCase()) ||
          res.dessituarec.toLowerCase().includes(text.toLowerCase())
      })
    },
    // handleSizeChange (val) {
    //   this.itemsPerPage = val
    //   this.handlePagination()
    // },

    getDate (date) {
      const fech = new Date(date.valueDate)
      return fech.toLocaleDateString('es-ES')
    },

    // handleCurrentChange (val) {
    //   this.currentPageData = val
    //   this.handlePagination()
    // },

    // handlePagination (arr) {
    //   if (Array.isArray(this.data)) {
    //     this.tableData = this.data.slice(
    //       (this.currentPageData - 1) * this.itemsPerPage,
    //       this.currentPageData * this.itemsPerPage)
    //   }
    // },

    getType (row) {
      switch (row) {
        case 2:
        case 6:
        case 10:
          return 'success'
        case 1:
        case 8:
          return 'warning'
        default:
          return 'danger'
      }
    }
  },

  mounted () {
    this.getInitialData()
    // if (Array.isArray(this.data)) this.totalData = this.data.length
    // this.handlePagination()
  }
}
</script>

<style lang="scss" scoped>
.notfound {
  margin-top: rem(28)
}

/deep/ .ods-table__row {
  cursor: pointer;
}

/deep/ .ods-table__expanded-cell {
  padding: rem(12) rem(24)!important;
  background: #F9F9FB;
}

/deep/ .ods-table__expanded-cell:hover {
  background-color: #F9F9FB!important;
}

/deep/ .ods-table__expanded-cell:hover td {
  border-bottom: 1px solid #d1d9de;
}

.tramos {
  .title {
    text-transform: uppercase;
  }

  .ods-table {
    background: #fff;
    margin: 12px 0;
  }

  /deep/ .ods-table thead th {
    padding: 0;
  }

  /deep/ .ods-table td, .ods-table th {
    padding: 4px 0;
  }

  /deep/ .ods-table__row--striped > td {
    background: #F0F0F0!important;
  }
}
</style>
